import React from "react";
import { DropdownProps } from "react-day-picker";
import { Dropdown } from "./Dropdown";

/**
 * Replacement Dropdown component compatible with react-day-picker.
 */
export function DayPickerDropdown(props: DropdownProps) {
  const { options, value, onChange, disabled, "aria-label": ariaLabel } = props;

  return (
    <Dropdown
      value={value !== undefined ? value.toString() : undefined}
      variant="ghost"
      isDisabled={disabled}
      ariaLabel={ariaLabel}
      options={(options ?? []).map((option) => ({
        value: option.value.toString(),
        label: option.label,
        isDisabled: option.disabled,
      }))}
      onChange={(nextValue) => {
        if (onChange) {
          const changeEvent = {
            target: { value: nextValue },
          } as React.ChangeEvent<HTMLSelectElement>;

          onChange(changeEvent);
        }
      }}
    />
  );
}
